// setPushyToken.js
'use strict';

import { PUSHY_APP_ID } from '../RemoteConfigKeys.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import mergeMeData from '../action/mergeMeData.js';
import setBrowserPermissionData from '../action/setBrowserPermissionData.js';
import { pushy as pushyDebug } from '../resource/debug.js';

const log = pushyDebug.extend('log:setPushyToken');

/**
 * Set pushy token
 * @kind action
 * @return {Promise} Action promise.
 */
const setPushyToken = () => async (dispatch, getState) => {
  const pushyAppId = getRemoteConfigData(getState(), PUSHY_APP_ID);
  log('init', { pushyAppId });
  if (
    !pushyAppId ||
    !window.WebApp?.requestNotificationPermission ||
    !window.WebApp?.setPushyAppId
  ) {
    log('cancelled', { pushyAppId, WebApp: window.WebApp });
    return dispatch({ type: '' });
  }

  window.onNotificationPermissionUpdate = permissionState => {
    log('onNotificationPermissionUpdate()', { permissionState });
    dispatch(
      setBrowserPermissionData({
        permissionKey: 'notification',
        permissionState,
      })
    );

    if ('granted' !== permissionState) {
      log('cancelled', { permissionState });
      return;
    }

    window.onPushyToken = token => {
      log('onPushyToken()', { token });
      window.onPushyToken = function NULL() {};
      return dispatch(mergeMeData({ field: 'pushyToken', value: token }));
    };

    log('setPushyAppId()', { pushyAppId });
    window.WebApp?.setPushyAppId(pushyAppId);
  };

  log('requestNotificationPermission()');
  window.WebApp.requestNotificationPermission();

  return dispatch({ type: '' });
};

export default setPushyToken;
